import PopoverSeparator from './PopoverSeparator';

export default PopoverSeparator;
